// import React, {
//    useEffect,
//    useState
// } from "react";

// import socket from "../socket";
// // import notificationSound from "../assets/notification.mp3";
// const GlobalReminderPopup = () => {

//    const [reminders, setReminders] =
//       useState([]);

//    useEffect(() => {

//       socket.on(
//          "followupReminder",
//          (reminder) => {

//             setReminders((prev) => [

//                ...prev,

//                {
//                   ...reminder,
//                   popupId: Date.now()
//                }

//             ]);

//             playNotificationSound();

//             showBrowserNotification(
//                reminder
//             );

//          }
//       );

//       return () => {

//          socket.off(
//             "followupReminder"
//          );

//       };

//    }, []);

//    // Browser Notification
//    const showBrowserNotification =
//       (reminder) => {

//       if (
//          Notification.permission
//          === "granted"
//       ) {

//          new Notification(
//             "Follow-up Reminder",
//             {
//                body:
//                `${reminder.clientName} - ${reminder.contactPhone}`
//             }
//          );

//       }

//    };

//    // Notification Sound
//     const playNotificationSound =
//     async () => {

//    //  console.log(
//    //      "PLAY SOUND FUNCTION CALLED"
//    //  );

//     try {

//         if(
//             window.notificationAudio
//         ){

//             const clonedAudio =
//                 window
//                 .notificationAudio
//                 .cloneNode();

//             clonedAudio.volume = 1;

//             await clonedAudio.play();

//         }

//     } catch (error) {

//         console.log(
//             "Audio Error:",
//             error
//         );

//     }

//     };

//    // Close popup
//    const closePopup = (id) => {

//       setReminders((prev) =>
//          prev.filter(
//             (item) =>
//                item.popupId !== id
//          )
//       );

//    };

//    if(reminders.length === 0)
//       return null;

//    return (

//       <div className="fixed top-4 right-4 z-[999999] flex flex-col gap-4 w-[360px]">

//          {reminders.map((item) => (

//             <div
//                key={item.popupId}
//                className="bg-white border border-gray-200 shadow-2xl rounded-2xl overflow-hidden animate-slideIn"
//             >

//                {/* Header */}
//                <div className="bg-gradient-to-r from-red-600 to-red-500 px-4 py-3 flex justify-between items-center">

//                   <div>

//                      <h2 className="text-white font-bold text-base">

//                         Follow-up Reminder

//                      </h2>

//                      <p className="text-red-100 text-xs">

//                         Time to contact client

//                      </p>

//                   </div>

//                   <button
//                      onClick={() =>
//                         closePopup(
//                            item.popupId
//                         )
//                      }
//                      className="text-white hover:bg-white/20 rounded-full p-1 transition"
//                   >

//                      ✕

//                   </button>

//                </div>

//                {/* Body */}
//                <div className="p-4">

//                   {/* Client */}
//                   <div className="mb-4">

//                      <p className="text-xs text-gray-500 mb-1">

//                         CLIENT NAME

//                      </p>

//                      <h3 className="text-lg font-bold text-gray-800">

//                         {item.clientName}

//                      </h3>

//                   </div>

//                   {/* Contact Info */}
//                   <div className="space-y-3">

//                      <div className="flex items-center justify-between bg-gray-50 rounded-xl px-3 py-2">

//                         <div>

//                            <p className="text-xs text-gray-500">

//                               Contact Person

//                            </p>

//                            <p className="font-medium text-gray-700">

//                               {item.contactName}

//                            </p>

//                         </div>

//                         <span className="text-xl">

//                            👤

//                         </span>

//                      </div>

//                      <div className="flex items-center justify-between bg-gray-50 rounded-xl px-3 py-2">

//                         <div>

//                            <p className="text-xs text-gray-500">

//                               Mobile Number

//                            </p>

//                            <p className="font-medium text-gray-700">

//                               {item.contactPhone}

//                            </p>

//                         </div>

//                         <span className="text-xl">

//                            📞

//                         </span>

//                      </div>

//                      <div className="flex items-center justify-between bg-gray-50 rounded-xl px-3 py-2">

//                         <div>

//                            <p className="text-xs text-gray-500">

//                               Follow-up Time

//                            </p>

//                            <p className="font-medium text-gray-700">

//                               {new Date(
//                                  `1970-01-01T${item.nextFollowUpTime}`
//                               ).toLocaleTimeString(
//                                  "en-IN",
//                                  {
//                                     hour: "numeric",
//                                     minute: "2-digit",
//                                     hour12: true
//                                  }
//                               )}

//                            </p>

//                         </div>

//                         <span className="text-xl">

//                            ⏰

//                         </span>

//                      </div>

//                   </div>

//                   {/* Buttons */}
//                   <div className="flex gap-3 mt-5">

//                      <a
//                         href={`tel:${item.contactPhone}`}
//                         className="flex-1 bg-green-600 hover:bg-green-700 text-white text-center py-2.5 rounded-xl font-semibold transition"
//                      >

//                         Call Now

//                      </a>

//                      <button
//                         onClick={() =>
//                            closePopup(
//                               item.popupId
//                            )
//                         }
//                         className="flex-1 bg-gray-100 hover:bg-gray-200 text-gray-700 py-2.5 rounded-xl font-semibold transition"
//                      >

//                         Dismiss

//                      </button>

//                   </div>

//                </div>

//             </div>

//          ))}

//       </div>

//    );

// };

// export default GlobalReminderPopup;

import React, {
   useEffect,
   useState,
   useRef
} from "react";
import { useSelector } from "react-redux";

import socket from "../socket";

const GlobalReminderPopup = () => {
   const [reminders, setReminders] = useState([]);

   const user = useSelector((state) => state?.user?.userDetails);

   const userRef = useRef(user);
   useEffect(() => {
      userRef.current = user;
   }, [user]);

   useEffect(() => {
      socket.on(
         "followupReminder",
         (reminder) => {
            const currentUser = userRef.current;
            
            const isOwner = currentUser?.role === "owner";

            const isSalesTeamDept = currentUser?.departmentId?.name === "Sales Team";

            if (isOwner || isSalesTeamDept) {
               setReminders((prev) => [
                  ...prev,
                  {
                     ...reminder,
                     popupId: Date.now()
                  }
               ]);

               playNotificationSound();

               showBrowserNotification(
                  reminder
               );
            } else {
               console.log("Reminder popup blocked: User is neither Owner nor in Sales Team department.");
            }
         }
      );

      return () => {
         socket.off(
            "followupReminder"
         );
      };
   }, []);

   // Browser Notification
   const showBrowserNotification =
      (reminder) => {

      if (
         Notification.permission
         === "granted"
      ) {

         new Notification(
            "Follow-up Reminder",
            {
               body:
               `${reminder.clientName} - ${reminder.contactPhone}`
            }
         );

      }

   };

   // Notification Sound
    const playNotificationSound =
    async () => {

    try {

        if(
            window.notificationAudio
        ){

            const clonedAudio =
                window
                .notificationAudio
                .cloneNode();

            clonedAudio.volume = 1;

            await clonedAudio.play();

        }

    } catch (error) {

        console.log(
            "Audio Error:",
            error
        );

    }

    };

   // Close popup
   const closePopup = (id) => {

      setReminders((prev) =>
         prev.filter(
            (item) =>
               item.popupId !== id
         )
      );

   };

   if(reminders.length === 0)
      return null;

   return (

      <div className="fixed top-4 right-4 z-[999999] flex flex-col gap-4 w-[360px]">

         {reminders.map((item) => (

            <div
               key={item.popupId}
               className="bg-white border border-gray-200 shadow-2xl rounded-2xl overflow-hidden animate-slideIn"
            >

               {/* Header */}
               <div className="bg-gradient-to-r from-red-600 to-red-500 px-4 py-3 flex justify-between items-center">

                  <div>

                     <h2 className="text-white font-bold text-base">

                        Follow-up Reminder

                     </h2>

                     <p className="text-red-100 text-xs">

                        Time to contact client

                     </p>

                  </div>

                  <button
                     onClick={() =>
                        closePopup(
                           item.popupId
                        )
                     }
                     className="text-white hover:bg-white/20 rounded-full p-1 transition"
                  >

                     ✕

                  </button>

               </div>

               {/* Body */}
               <div className="p-4">

                  {/* Client */}
                  <div className="mb-4">

                     <p className="text-xs text-gray-500 mb-1">

                        CLIENT NAME

                     </p>

                     <h3 className="text-lg font-bold text-gray-800">

                        {item.clientName}

                     </h3>

                  </div>

                  {/* Contact Info */}
                  <div className="space-y-3">

                     <div className="flex items-center justify-between bg-gray-50 rounded-xl px-3 py-2">

                        <div>

                           <p className="text-xs text-gray-500">

                              Contact Person

                           </p>

                           <p className="font-medium text-gray-700">

                              {item.contactName}

                           </p>

                        </div>

                        <span className="text-xl">

                           👤

                        </span>

                     </div>

                     <div className="flex items-center justify-between bg-gray-50 rounded-xl px-3 py-2">

                        <div>

                           <p className="text-xs text-gray-500">

                              Mobile Number

                           </p>

                           <p className="font-medium text-gray-700">

                              {item.contactPhone}

                           </p>

                        </div>

                        <span className="text-xl">

                           📞

                        </span>

                     </div>

                     <div className="flex items-center justify-between bg-gray-50 rounded-xl px-3 py-2">

                        <div>

                           <p className="text-xs text-gray-500">

                              Follow-up Time

                           </p>

                           <p className="font-medium text-gray-700">

                              {new Date(
                                 `1970-01-01T${item.nextFollowUpTime}`
                              ).toLocaleTimeString(
                                 "en-IN",
                                 {
                                    hour: "numeric",
                                    minute: "2-digit",
                                    hour12: true
                                 }
                              )}

                           </p>

                        </div>

                        <span className="text-xl">

                           ⏰

                        </span>

                     </div>

                  </div>

                  {/* Buttons */}
                  <div className="flex gap-3 mt-5">

                     <a
                        href={`tel:${item.contactPhone}`}
                        className="flex-1 bg-green-600 hover:bg-green-700 text-white text-center py-2.5 rounded-xl font-semibold transition"
                     >

                        Call Now

                     </a>

                     <button
                        onClick={() =>
                           closePopup(
                              item.popupId
                           )
                        }
                        className="flex-1 bg-gray-100 hover:bg-gray-200 text-gray-700 py-2.5 rounded-xl font-semibold transition"
                     >

                        Dismiss

                     </button>

                  </div>

               </div>

            </div>

         ))}

      </div>

   );

};

export default GlobalReminderPopup;